import { Button, Link, TextField, Typography,CircularProgress } from "@mui/material";
//import Spark_Logo from "../../../assets/Spark-Logo.svg";
import { useFormik } from "formik";
import "./Forgotpassword.css";
import * as Yup from "yup";
import { CONSTANT } from "../../../shared/constants/constant-data";
import axiosInstance from "../../../services/axiosInstance";
import { toast } from "react-toastify";
import ReCAPTCHA from "react-google-recaptcha";
import { captchaConfig, isOfflineCaptcha, SITE_KEY } from "../shared/captcha-constants";
import AppCaptcha from "../../../components/captcha";
import { useRef, useState } from "react";
import DoneIcon from "@mui/icons-material/Done";
import { RESEND_PASSWORD } from "../../../shared/constants/apiEndpoints";
import Spark_Logo from "../../../assets/baseVersion/Spark_Newlogo.svg";
import React from "react";
import AuthLayout from "../../../components/layout/auth_layout";

const validation_schema = Yup.object().shape({
  username: Yup.string()
    .email()
    .required(CONSTANT.AUTHENTICATION.AUTH_ORG_EMAIL_VAILD),
});

const ForgotPassword = () => {
  const recaptchaRef = useRef<any>(null);
  const [captchaToken, setCaptchaToken] = useState("");
  const [isCaptchaValid, setIsCaptchaValid] = useState(false);
  const [isForgotPasswordSuccess, setIsForgotPasswordSuccess] = useState(false);
  const [resendCount, setResendCount] = useState(0); 
    const [loading, setLoading] = useState(false);
      // const [email, setEmail] = useState("");

      const [isButtonDisabled, setIsButtonDisabled] = React.useState(false);
    

      const lastErrorMessageRef = React.useRef<string | null>(null);
        const toastTimeoutRef = React.useRef<NodeJS.Timeout | null>(null);
        const toastDuration = 5000;  
  

  const handleCaptchaChange = (token: any) => {
    setCaptchaToken(token);
  };

  const handleOfflineCaptchaChange = (isValid: boolean) => {
    setIsCaptchaValid(isValid);
  };

  const handleForgotPassword = async (email: string) => {
    console.log(email, 'email');
    setLoading(true)
    
    try {
      const response = await axiosInstance.post(RESEND_PASSWORD
        ,
        {
          email: email
        }
      );
      toast(response.data.message, { type: "success" });
      setIsForgotPasswordSuccess(true);
    }  catch (error: any) {
      console.error("Error changing password:", error);
      const errorMessage =
        error?.response?.data?.message || "Something went wrong";

      // Only show toast if error message is different or previous toast duration has ended
      if (
        lastErrorMessageRef.current !== errorMessage ||
        !toastTimeoutRef.current
      ) {
        toast(errorMessage, { type: "error" });
        lastErrorMessageRef.current = errorMessage;
        if (toastTimeoutRef.current) {
          clearTimeout(toastTimeoutRef.current);
        }
        toastTimeoutRef.current = setTimeout(() => {
          toastTimeoutRef.current = null;
          lastErrorMessageRef.current = null;
        }, toastDuration);
      }
      setIsButtonDisabled(false);
    } finally {
      setIsButtonDisabled(false);
      setLoading(false);
    }
  };

  const formik = useFormik({
    initialValues: {
      username: "",
    },
    validationSchema: validation_schema,
    onSubmit: () => {
      handleForgotPassword(formik.values.username);
    },
  });

  const handleResendEmail = () => {
    if (resendCount < 3) {
      handleForgotPassword(formik.values.username);
      setResendCount(resendCount + 1);
    }
  };

  return (
    <>
    <AuthLayout>
      {isForgotPasswordSuccess ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "50vh",
          }}
        >
          <DoneIcon
            sx={{ color: "green", height: "100px", width: "100px", marginBottom: 3 }}
          />
          <Typography sx={{ mb: 5 }}>
            <strong>Check your email to reset your password!</strong>
          </Typography>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mb: 3 }}
            onClick={handleResendEmail}
            disabled={resendCount >= 3} // Disable button after three clicks
          >
            Resend Email
          </Button>
          <Link
            href="/login"
            sx={{ color: "#343a40!important", fontWeight: 600, fontSize: "14px" }}
          >
            Go To Login Page
          </Link>
        </div>
      ) : (
        <div className="login-container">
          <div className="login_logo">
            <img src={Spark_Logo} alt="Login Logo" />
          </div>
          <h5 className="mb_2 font_bold mt_0">Forgot Password?</h5>
          <p
            style={{
              opacity: 0.5,
              fontSize: "14px",
              lineHeight: "20px",
              fontWeight: "500",
              marginBottom: "18px",
            }}
          >
            Don't worry we are here to reset it{" "}
          </p>
          <Typography
            sx={{ fontWeight: 400, fontSize: "14px", marginBottom: "18px" }}
          >
            Enter your email, we will send you the retrieve link
          </Typography>
          <form onSubmit={formik.handleSubmit} autoComplete="off" spellCheck={false}>
            <TextField
              id="username"
              label="Email"
              variant="outlined"
              required
              fullWidth
              name="username"
              autoComplete="off"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.username}
              error={formik.touched.username && Boolean(formik.errors.username)}
              helperText={formik.touched.username && formik.errors.username}
              className="mb_3"
              inputProps={{
                autoComplete: "off",
                autoCorrect: "off",
                autoCapitalize: "none",
                "data-lpignore": "true",
                "data-1p-ignore": "true",
              }}
            />

            <div className="mb_3">
              {isOfflineCaptcha ? (
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey={SITE_KEY}
                  onChange={handleCaptchaChange}
                />
              ) : (
                <AppCaptcha
                  config={captchaConfig}
                  onCaptchaStatus={handleOfflineCaptchaChange}
                />
              )}
            </div>

            <Button
              fullWidth
              variant="contained"
              color="primary"
              disabled={!formik.isValid || !formik.dirty || (!captchaToken && !isCaptchaValid) || loading || isButtonDisabled}
              className={`btn btn-primary`}
                endIcon={
                              loading ? <CircularProgress size={15} color="inherit" /> : null
                            }
              type="submit"
            >
              Send Email
            </Button>
          </form>
        </div>
      )}
      </AuthLayout>
    </>
  );
};

export default ForgotPassword;